import { useListStore } from "./ListStore";
import { useConversionStore } from "./ConversionStore";

export function isVueListLoading(listStoreId: string, conversionStoreId: string): boolean {
	const listStore = useListStore(listStoreId);
	if (listStore.items.length === 0) {
		return listStore.totalCountEstimate > 0;
	}
	return Boolean(useConversionStore(conversionStoreId).isResetting);
}
